import Phaser from "phaser";

export class EffectPool {
  private readonly available = new Map<string, Phaser.GameObjects.Image[]>();
  private readonly active = new Set<Phaser.GameObjects.Image>();
  constructor(
    private readonly scene: Phaser.Scene,
    private readonly depth: number,
  ) {}
  acquire(texture: string): Phaser.GameObjects.Image {
    const bucket = this.available.get(texture) ?? [],
      image = bucket.pop() ?? this.scene.add.image(0, 0, texture);
    this.available.set(texture, bucket);
    this.active.add(image);
    image
      .setTexture(texture)
      .setDepth(this.depth)
      .setVisible(true)
      .setActive(true)
      .setAlpha(1)
      .setScale(1)
      .setRotation(0);
    return image;
  }
  release(image: Phaser.GameObjects.Image): void {
    if (!this.active.delete(image)) return;
    this.scene.tweens.killTweensOf(image);
    image.setVisible(false).setActive(false);
    const bucket = this.available.get(image.texture.key) ?? [];
    bucket.push(image);
    this.available.set(image.texture.key, bucket);
  }
  destroy(): void {
    for (const image of this.active) image.destroy();
    for (const bucket of this.available.values()) for (const image of bucket) image.destroy();
    this.active.clear();
    this.available.clear();
  }
}
